module.exports = function(app) {
	'use strict';
	app.service('planAdmin', ['sessionData', 'coverageBuddy', function(sessionData, coverageBuddy) {

		var getEmployerInfo = function() {
			return sessionData.employerInfo;
		};

		var getEntitlements = function() {
			return sessionData.entitlements;
		};

		var getUCCIGroupNumbers = function() {
			return sessionData.employerInfo.ucciGroupNumbers || [];
		};
		this.getUCCIGroupNumbers = getUCCIGroupNumbers;

		var getGroupLevelEntitlements = function() {
			return sessionData.employerInfo.planAdministratorEntitlements.groupLevelEntitlements;
		};

		this.canModifyGroupNumber = function(groupNumber) {
			var entitlements = getEntitlements();
			var groupLevelEntitlements = getGroupLevelEntitlements();
			var ucciGroupNumbers = getUCCIGroupNumbers();

			return (
				groupLevelEntitlements[groupNumber] &&
				groupLevelEntitlements[groupNumber]['Employee Data'] &&
				groupLevelEntitlements[groupNumber]['Employee Data'].toLowerCase &&
				groupLevelEntitlements[groupNumber]['Employee Data'].toLowerCase() === 'modify'
			) || (
				entitlements.employees.edit && // for ucciGroupNumbers, any modify is good enough
				ucciGroupNumbers.indexOf(groupNumber) >= 0
			);
		};

		this.canOnlyViewGroupNumber = function(groupNumber) {
			var entitlements = getEntitlements();
			var groupLevelEntitlements = getGroupLevelEntitlements();
			var ucciGroupNumbers = getUCCIGroupNumbers();

			return (
				groupLevelEntitlements[groupNumber] &&
				groupLevelEntitlements[groupNumber]['Employee Data'] &&
				groupLevelEntitlements[groupNumber]['Employee Data'].toLowerCase &&
				groupLevelEntitlements[groupNumber]['Employee Data'].toLowerCase() === 'view'
			) || (
				!(entitlements.employees.edit && ucciGroupNumbers.indexOf(groupNumber) >= 0) &&  // they do not have modify, but
				(entitlements.employees.view && ucciGroupNumbers.indexOf(groupNumber) >= 0)      // they do have view
			);
		};

		this.hasAnySpendingView = function() {
			return (
				sessionData.entitlements.spending.claimsView ||
				sessionData.entitlements.spending.claimsViewNew ||
				sessionData.entitlements.spending.noClaimsView ||
				sessionData.entitlements.spending.spendingAccountAccess
			);
		};

		this.extractModifiableData = function(clonedData) {
			var lePlanAdmin = this;
			[clonedData.subscriber].forEach(
				function(p) {
					p.memberCoverages = (p.memberCoverages || []).filter(
						function(c) {
							return Boolean(
								lePlanAdmin.canModifyGroupNumber(c.groupNumber) &&
								coverageBuddy.isGroupActive(p, c.groupNumber)
							);
						}
					)
				}
			);

            clonedData.dependents = clonedData.dependents.filter(
                function(d) {d.memberCoverages = (d.memberCoverages || []).filter(
                    function(co) {
                        return Boolean(
                            lePlanAdmin.canModifyGroupNumber(co.groupNumber) &&
                            coverageBuddy.isGroupActive(d, co.groupNumber)
                        );
                    }
                );
                    return d.memberCoverages.length;}
            );

			return clonedData;
		}.bind(this);

		this.hasModifiableData = function(employeeData) {
			var modifiableData = this.extractModifiableData( angular.copy(employeeData) );
			return [modifiableData.subscriber].concat(modifiableData.dependents).some(
				function(p) { return p.memberCoverages.length; }
			);
		}.bind(this)

	}]);
};
